<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Yeni Etkinlik Ekle">
                    <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                            <span><strong>Not:</strong> Eklenecek galeri adı ve arama motoru
                                bağlantı linki benzersiz olmalıdır...</span>
                        </div>
                    </b-alert>
                    <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                        to="/events">
                        Galeri Listesi
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
        <validation-observer ref="rules">
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="Galeri Ekleme Formu">
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Galeri Kategoriesi" label-for="galeryCategory">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Galeri Kategoriesi">
                                        <v-select id="galeryCategory" v-model="selectedGalleryCategory" label="name"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="galleryCategories" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Başlık" label-for="title">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Başlık">
                                        <b-form-input id="title" v-model="title" placeholder="Başlık"
                                            :state="errors.length > 0 ? false : null"
                                            :class="title.length >= chars.title ? 'text-danger' : ''" />
                                        <small class="textarea-counter-value float-right"
                                            :class="title.length >= chars.title ? 'bg-danger' : ''">
                                            <span class="char-count">{{ title.length }}</span>
                                            /
                                            {{ chars.title }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Bağlantı Başlığı">
                                        <b-form-input id="linkTitle" v-model="linkTitle" placeholder="Bağlantı Başlığı"
                                            :state="errors.length > 0 ? false : null" :class="linkTitle.length >= chars.linkTitle ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ linkTitle.length }}</span>
                                            /
                                            {{ chars.linkTitle }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="8">
                                <DragDropImage ref="refCardImage" dimensions="440x420" title="Kart Görseli" :imageUrl="null"
                                    :required="true">
                                </DragDropImage>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Görsel Başlığı (title)">
                                        <b-form-textarea id="imageTitle" v-model="imageTitle"
                                            placeholder="Görsel Başlığı (title)" rows="3" class="char-textarea"
                                            :state="errors.length > 0 ? false : null" :class="imageTitle.length >= chars.imageTitle
                                                    ? 'text-danger'
                                                    : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ imageTitle.length }}</span>
                                            /
                                            {{ chars.imageTitle }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Görsel Açıklaması (alt text)" label-for="imageAltText">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Görsel Açıklaması (alt text)">
                                        <b-form-textarea id="imageAltText" v-model="imageAltText"
                                            placeholder="Görsel Açıklaması (alt text)" rows="3" class="char-textarea"
                                            :state="errors.length > 0 ? false : null" :class="imageAltText.length >= chars.imageAltText
                                                    ? 'text-danger'
                                                    : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="imageAltText.length >= chars.imageAltText
                                                ? 'bg-danger'
                                                : ''
                                            ">
                                            <span class="char-count">{{ imageAltText.length }}</span>
                                            /
                                            {{ chars.imageAltText }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Bağlantı Linki" label-for="slug">
                                    <validation-provider #default="{ errors }" rules="required" name="Bağlantı Linki">
                                        <b-form-input id="slug" v-model="slug" placeholder="Bağlantı Linki"
                                            :state="errors.length > 0 || availability == false ? false : null"
                                            :class="slug.length >= chars.slug || availability == false ? 'text-danger' : ''" />
                                        <small class="textarea-counter-value float-right"
                                            :class="slug.length >= chars.slug ? 'bg-danger' : ''">
                                            <span class="char-count">{{ slug.length }}</span>
                                            /
                                            {{ chars.slug }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <div v-if="availability == false">
                                        <p class="text-danger"><small>Galeri linki benzersiz olmalıdır.</small></p>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Meta Açıklaması" label-for="metaTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true, min: 30 }"
                                        name="Meta Açıklaması">
                                        <b-form-textarea id="metaTitle" v-model="metaDescription"
                                            placeholder="Meta Açıklaması" rows="3" class="char-textarea"
                                            :state="errors.length > 0 ? false : null" :class="metaDescription.length >= chars.metaDescription
                                                    ? 'text-danger'
                                                    : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="metaDescription.length >= chars.metaDescription
                                                ? 'bg-danger'
                                                : ''
                                            ">
                                            <span class="char-count">{{
                                                metaDescription.length
                                            }}</span>
                                            /
                                            {{ chars.metaDescription }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Tarihler" label-for="text">
                                    <div>
                                        <!-- <b-form ref="form" :style="{ height: trHeight }" class="repeater-form" -->
                                        <b-form ref="form" :style="{ height: trHeight }" class="repeater-form"
                                            @submit.prevent="repeateAgain">
                                            <!--  Loop -->
                                            <div v-for="(galleryImage, index) in galleryImages" :id="galleryImage.id"
                                                :key="galleryImage.id" ref="row">
                                                <b-row>
                                                    <hr />
                                                </b-row>
                                                <b-row>
                                                    <b-col md="12">
                                                        <b-form-group label="Başlık" label-for="title">
                                                            <validation-provider #default="{ errors }" :rules="{
                                                                required: true,
                                                            }" name="Başlık">
                                                                <b-form-input v-model="galleryImages[index].title"
                                                                    placeholder="Başlık"
                                                                    :state="errors.length > 0 ? false : null" :class="title.length >= chars.title
                                                                            ? 'text-danger'
                                                                            : ''
                                                                        " />
                                                                <small class="textarea-counter-value float-right"
                                                                    :class="title.length >= chars.title
                                                                            ? 'bg-danger'
                                                                            : ''
                                                                        ">
                                                                    <span class="char-count">{{
                                                                        title.length
                                                                    }}</span>
                                                                    /
                                                                    {{ chars.title }}
                                                                </small>
                                                                <small class="text-danger">{{
                                                                    errors[0]
                                                                }}</small>
                                                            </validation-provider>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col>
                                                        <DragDropImage dimensions="310x430" :ref="`galleryImages-${index}`"
                                                            title="Galeri Görseli" :imageUrl="null" :required="true">
                                                        </DragDropImage>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <!-- Remove Button -->
                                                    <b-col lg="2" md="3" class="mb-50">
                                                        <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                                            variant="outline-danger" class="mt-0 mt-md-2"
                                                            @click="removeItem(index)">
                                                            <feather-icon icon="XIcon" class="mr-25" />
                                                            <span>Sil</span>
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                                <b-col cols="12">
                                                    <hr />
                                                </b-col>
                                            </div>
                                        </b-form>
                                    </div>
                                    <b-button class="mt-5" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                        @click="repeateAgain">
                                        <feather-icon icon="PlusIcon" class="mr-25" />
                                        <span>Görsel Ekle</span>
                                    </b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="mt-5"></b-col>
                            <b-col md="6" class="mt-5">
                                <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    variant="outline-success" @click="postConfirmText(false, false)">
                                    <b-spinner v-if="spinner === true && isDraft === false" small />
                                    {{
                                        spinner === true && isDraft === false
                                            ? "Yayınlanıyor"
                                            : "Yayınla"
                                    }}
                                </b-button>
                                <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    variant="outline-warning" @click="postConfirmText(true, false)">
                                    <b-spinner v-if="spinner == true && isDraft == true" small />
                                    {{
                                        spinner == true && isDraft == true
                                            ? "Taslağa Kaydediliyor"
                                    : "Taslağa Kaydet"
                                    }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BImg,
    BRow,
    BCol,
    BTime,
    BCard,
    BCardText,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormTimepicker,
    BFormCheckbox,
    BLink,
} from "bootstrap-vue";
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from "@validations";

import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        DragDropImage,
        Editor,
        BImg,
        BRow,
        BCol,
        BTime,
        BLink,
        BCard,
        BCardText,
        BButton,
        BForm,
        BSpinner,
        BAlert,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BFormTextarea,
        BMedia,
        BMediaAside,
        BMediaBody,
        BFormFile,
        BFormDatepicker,
        BFormTimepicker,
        BFormCheckbox,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        required,
        email,
        confirmed,
        url,
        between,
        alpha,
        integer,
        password,
        min,
        digits,
        alphaDash,
        length,
    },
    directives: {
        Ripple,
    },
    mixins: [heightTransition],
    data() {
        return {
            id: "",
            slug: "",
            title: "",
            image: null,
            spinner: false,
            isDraft: false,
            linkTitle: "",
            nextTodoId: 2,
            imageTitle: "",
            imageAltText: "",
            metaDescription: "",
            availability: true,
            galleryCategories: [],
            selectedGalleryCategory: {},
            slugParam: this.$route.params.slugParam,
            targetLocale: this.$route.query.targetLocale,
            chars: {
                slug: 255,
                title: 55,
                linkTitle: 55,
                imageTitle: 60,
                imageAltText: 140,
                metaDescription: 160,
            },
            galleryImages: [
                {
                    id: 1,
                    title: null,
                    image: null
                },
            ]
        };
    },
    watch: {
        title(newTitle, oldTitle) {
            this.slug = newTitle;
            this.linkTitle = newTitle;
            this.imageTitle = newTitle;
            this.imageAltText = newTitle;
        },
        slug(newSlug, oldSlug) {
            this.slug = this.slugify(newSlug);
            this.slugAvailability(this.slug);
        }
    },
    methods: {
        slugify(text, ampersand = "and") {
            const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
            const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
            const p = new RegExp(a.split("").join("|"), "g");
            return text
                .toString()
                .toLowerCase()
                .replace(/[\s_]+/g, "-")
                .replace(p, (c) => b.charAt(a.indexOf(c)))
                .replace(/&/g, `-${ampersand}-`)
                .replace(/[^\w-]+/g, "")
                .replace(/--+/g, "-")
                .replace(/^-+|-+$/g, "");
        },
        slugAvailability(slug) {
            let formData = new FormData();
            formData.append("id", null);
            formData.append("slug", slug);
            endpoints
                .postGalleriesAvailability(formData, this.targetLocale, () => { })
                .then((data) => {
                    this.availability = data.response.availability
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        repeateAgain() {
            this.galleryImages.push({
                id: (this.nextTodoId += this.nextTodoId),
                title: null,
                image: null

            });

            this.$nextTick(() => {
                this.trAddHeight(this.$refs.row[0].offsetHeight);
            });
        },
        removeItem(index) {
            this.galleryImages.splice(index, 1);
            this.trTrimHeight(this.$refs.row[0].offsetHeight);
        },
        initTrHeight() {
            this.trSetHeight(null);
            this.$nextTick(() => {
                this.trSetHeight(this.$refs.form.scrollHeight);
            });
        },
        onContext(ctx) {
            this.context = ctx;
        },
        postConfirmText(isDraft, preview) {
            this.isDraft = isDraft;
            this.$swal({
                title: "Kayıt?",
                text: "Yeni galeriyi kaydetmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.postSubmit(preview);
                }
            });
        },
        getGalleryCategories() {
            endpoints
                .getGalleryCategories(null, this.targetLocale, () => { })
                .then((data) => {
                    this.galleryCategories = [...data.response];
                    this.selectedGalleryCategory = this.galleryCategories[0];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getGalleriesBySlug() {
            endpoints.getGalleriesBySlug(this.slugParam, this.$i18n.locale, () => { })
                .then((data) => {
                    this.gallery = data.response;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        postSubmit(preview) {
            if (this.availability) {
                this.$refs.rules.validate().then((success) => {
                    if (success) {
                        this.spinner = true;
                        let formData = new FormData()
                        console.log(this.galleryImages)
                        for (let index = 0; index < this.galleryImages.length; index++) {
                            this.galleryImages[index].image = this.$refs[`galleryImages-${index}`][0].image
                            formData.append(`galleryImages[${index}][title]`, this.galleryImages[index].title);
                            formData.append(`galleryImages[${index}][image]`, this.$refs[`galleryImages-${index}`][0].image)
                        }
                        formData.append("galleryCategoryId", this.selectedGalleryCategory.id)
                        formData.append("slug", this.slug)
                        formData.append("title", this.title)
                        formData.append("image", this.$refs.refCardImage.image)
                        formData.append("linkTitle", this.linkTitle)
                        formData.append("imageTitle", this.imageTitle)
                        formData.append("imageAltText", this.imageAltText)
                        formData.append("metaDescription", this.metaDescription)
                        formData.append("isDraft", this.isDraft)

                        endpoints
                            .postGalleries(formData, this.targetLocale, () => { })
                            .then((data) => {
                                this.spinner = false;
                                if (data.status) {
                                    if (preview == true) {
                                        window.open(`${settings.uiBaseUrl}/galleries/preview/${this.slug}?hl=${this.targetLocale}`, '_blank');
                                    }
                                    this.$swal({
                                        icon: "success",
                                        title: "Kayıt başarılı!",
                                        text: "Yeni galeri eklendi.",
                                        customClass: {
                                            confirmButton: "btn btn-success",
                                        },
                                    }).then((result) => {
                                        if (result.value) {
                                            this.$router.push({
                                                path: `/galleries`,
                                            });
                                        }
                                    });
                                } else {
                                    this.$swal({
                                        title: 'Hata!',
                                        text: 'Galeri bağlantı linki benzersiz değil!',
                                        icon: 'error',
                                        confirmButtonText: "Tamam",
                                        customClass: {
                                            confirmButton: 'btn btn-primary',
                                        },
                                    }).then((result) => {
                                        if (result.value) {

                                        }
                                    });
                                }
                            })
                            .catch((err) => {
                                this.spinner = false;
                                console.log(err);
                            });
                    }
                });
            } else {
                this.$swal({
                    title: 'Hata!',
                    text: 'Galeri bağlantı linki benzersiz değil!',
                    icon: 'error',
                    confirmButtonText: "Tamam",
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then((result) => {
                    if (result.value) {

                    }
                });
            }
        },
    },
    created() {
        window.addEventListener("resize", this.initTrHeight);
    },
    destroyed() {
        window.removeEventListener("resize", this.initTrHeight);
    },
    mounted() {
        this.initTrHeight();
        this.getGalleryCategories();
    },
    setup() { },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>